import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React from 'react';
import { IDoorInstallationModel } from '../../../../entities-generated/models/project/door-installation-model';
import { CartDoorListing } from '../cart-door-listing';
import { CartHandleListing } from '../cart-handle-listing';
import { BwjCard } from '../../../../framework/components/bwj-layout';

interface ICartInstallationListingProps {
  installation: IDoorInstallationModel;
  allowExclusion: boolean;
  supressNotification: boolean;
  onExclude: (installation: IDoorInstallationModel) => void;
  onInclude: (installation: IDoorInstallationModel) => void;
  onDoorSelected: (installation: IDoorInstallationModel) => void;
  onHandleSelected: (installation: IDoorInstallationModel) => void;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    padding: '0.5rem',
    paddingBottom: '0.75rem',
    margin: 0,
    marginBottom: '1rem',
  };

  const handleContainer: IStyle = {
    paddingTop: '0.75rem',
    borderTop: `1px solid ${theme.palette.neutralQuaternary}`,
    marginTop: '0.75rem',
  };

  return mergeStyleSets({
    root,
    handleContainer,
  });
}

export const CartInstallationListing: React.FunctionComponent<ICartInstallationListingProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);

  return (
    <BwjCard className={cs.root}>
      <CartDoorListing
        door={props.installation}
        onSelected={() => props.onDoorSelected(props.installation)}
        onExclude={props.allowExclusion ? () => props.onExclude(props.installation) : undefined}
        onInclude={() => props.onInclude(props.installation)}
        suppressNotification={props.supressNotification}
      />
      {!!props.installation.selectedDoor && props.installation.selectHandle && props.installation.isExcluded === false &&
      <div className={cs.handleContainer}>
        <CartHandleListing
          installation={props.installation}
          onSelected={() => props.onHandleSelected(props.installation)}
        />
      </div>}
    </BwjCard>
  );
};
